import { render, staticRenderFns } from "./CostSupervisionTable.vue?vue&type=template&id=13a61c42&scoped=true&"
import script from "./CostSupervisionTable.vue?vue&type=script&lang=js&"
export * from "./CostSupervisionTable.vue?vue&type=script&lang=js&"
import style0 from "./CostSupervisionTable.vue?vue&type=style&index=0&id=13a61c42&prod&scoped=true&lang=css&"
import style1 from "./CostSupervisionTable.vue?vue&type=style&index=1&id=13a61c42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a61c42",
  null
  
)

export default component.exports